import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ApiService from "../../Service/ApiService";
import Header from "../common/Header";
import { Button, Form, Input, InputNumber, Select } from "antd";
import UploadInput from "../common/upload/UploadInput";
import { LoadingOutlined } from "@ant-design/icons";
import "../common/forms.css";

const EditRoomPage = () => {
  const { roomId } = useParams();
  const navigate = useNavigate();
  const [hotels, setHotels] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    const fetchRoomDetails = async () => {
      const response = await ApiService.getRoomById(roomId);
      const hotelList = await ApiService.fetchHotels();
      const hotelSelectOptions = hotelList.map((hotel) => ({
        label: hotel.name,
        value: hotel.id,
      }));
      setHotels(hotelSelectOptions);
      form.setFieldsValue({
        hotel: response?.hotelId,
        roomPhotoUrl: response?.roomPhotoUrl,
        roomType: response?.roomType,
        roomPrice: response?.roomPrice,
        roomDescription: response?.roomDescription,
        maxPersons: response?.maxPersons ?? 0,
        roomName: response?.roomName,
        version: response?.version ?? 0,
      });
    };
    fetchRoomDetails();
  }, [roomId, form]);

  const handleUpdate = async (values) => {
    if (!window.confirm("Do you want to update this room?")) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("roomType", values.roomType);
    formData.append("roomPrice", values.roomPrice);
    formData.append("roomDescription", values.roomDescription);
    formData.append("hotel", values.hotel);
    formData.append("maxPersons", values.maxPersons);
    formData.append("roomName", values.roomName);
    formData.append("version", values.version ?? 0);

    if (values.photo && values.photo.length > 0) {
      formData.append("photo", values.photo[0].originFileObj);
    }

    const result = await ApiService.updateRoom(roomId, formData);
    setLoading(false);
    if (result) {
      setTimeout(() => navigate("/admin/manage-rooms"), 1000);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Do you want to delete this room?")) {
      const result = await ApiService.deleteRoom(roomId);
      if (result) {
        setTimeout(() => navigate("/admin/manage-rooms"), 1000);
      }
    }
  };

  return (
    <div className="default-container">
      <Header title={"Edit Room"} />
      <div className="form-page-container">
        <Form
          form={form}
          name="edit-room-form"
          layout="vertical"
          onFinish={handleUpdate}
        >
          <Form.Item
            name={"photo"}
            label="Photo of the room"
            getValueFromEvent={(e) => e}
            valuePropName="value"
          >
            <UploadInput
              allowedFileTypes={["image/png", "image/jpg", "image/jpeg"]}
              name={"roomPhoto"}
            />
          </Form.Item>

          <Form.Item
            name={"hotel"}
            label="Hotel"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Select options={hotels} size="large" />
          </Form.Item>

          <Form.Item
            name={"roomName"}
            label="Room Name"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name={"roomType"}
            label="Room Type"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input size="large" />
          </Form.Item>

          <Form.Item
            name={"roomPrice"}
            label="Room Price"
            rules={[
              { required: true, message: "This field is required" },
              {
                validator: (_, value) =>
                  value >= 1
                    ? Promise.resolve()
                    : Promise.reject(new Error("Value must be at least 1")),
              },
            ]}
          >
            <InputNumber size="large" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name={"maxPersons"}
            label="Max Persons"
            rules={[
              { required: true, message: "This field is required" },
              {
                validator: (_, value) =>
                  value >= 1
                    ? Promise.resolve()
                    : Promise.reject(new Error("Value must be at least 1")),
              },
            ]}
          >
            <InputNumber size="large" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name={"roomDescription"}
            label="Room Description"
            rules={[{ required: true, message: "This field is required" }]}
          >
            <Input.TextArea rows={5} size="large" />
          </Form.Item>

          <Form.Item name={"version"} hidden>
            <Input />
          </Form.Item>

          <Form.Item className="action-button-default">
            <Button
              type="primary"
              htmlType="submit"
              disabled={loading}
              style={{ marginRight: 8 }}
            >
              {loading ? <LoadingOutlined /> : "Update Room"}
            </Button>
            <Button danger onClick={handleDelete} disabled={loading}>
              Delete Room
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
export default EditRoomPage;
